<template>
  <div class="profile">
    <v-container grid-list-md fluid class="pt-0 pb-0">
      <v-card class="pa-2 mb-2 card-r">
        <v-layout row class="px-0">
          <v-flex >
            <v-tabs
              slot="extension"
              class="top-tab w-100"
              v-model="profileTabs"
              centered
              hide-slider
              fixed-tabs
              color="transparent"
            >
              <v-tabs-slider color="blue"></v-tabs-slider>

              <v-tab to="#StudentPersonal" class="primary--text f-12 w-33 text-capitalize">Student Personal</v-tab>
              <v-tab to="#StudentClasses" class="primary--text f-12 w-33 text-capitalize">Classes</v-tab>
              <!--<v-tab to="#PastClasses" class="primary&#45;&#45;text f-12 w-33 text-capitalize">Past Classes</v-tab>-->
              <v-tab to="#StudentInvoice" class="primary--text f-12 w-33 text-capitalize word-break">Subscription</v-tab>
              <!--<v-tab href="#PaymentMethod" class="primary&#45;&#45;text f-12 w-33" disable>Payment Method</v-tab>-->
              <!--<v-tab href="#StudentInvoice" class="primary&#45;&#45;text f-12">Student Invoice</v-tab>-->


            </v-tabs>
          </v-flex>
        </v-layout>
      </v-card>
      <!--<v-card class="pa-2 card-r grey lighten-4">-->
      <v-layout>
        <v-flex>
          <v-tabs-items v-model="profileTabs">
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="StudentPersonal" >
              <student-personal/>
            </v-tab-item>
            <v-tab-item id="StudentClasses">
              <student-classes :id="studentId"/>
            </v-tab-item>
            <!--<v-tab-item id="PastClasses">-->
              <!--<past-classes/>-->
            <!--</v-tab-item>-->
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="StudentInvoice">
              <packages/>
            </v-tab-item>
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="PaymentMethod">
              <payment-method/>
            </v-tab-item>
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="packages">
              <student-invoice/>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
      <!--</v-card>-->
    </v-container>
  </div>
</template>
<script>
  /* eslint-disable */
  import StudentPersonal from "./StudentPersonal";
  import Packages from "./Packages";
  import PaymentMethod from "./PaymentMethod";
  import StudentClasses from "./StudentClasses";
  import PastClasses from "./PastClasses"
  import StudentInvoice from "./StudentInvoice";
  export default {
    name: "AdminProfile",
    data: () => ({
      studentId:'',
      profileTabs: null
    }),
    created:function(){
      var studentDetails = Store.state.studentDetails;
      this.studentId=studentDetails.id
      var packageId=studentDetails.packages[0].id
      // Store.dispatch('getStudentClass', {'studentid':this.studentId, 'packageid':packageId});
    },
    components: {
      StudentPersonal,
      Packages,
      PaymentMethod,
      StudentClasses,
      PastClasses,
      StudentInvoice,
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/profile/student/StudentProfile.vue